module.exports = __webpack_public_path__ + "static/media/splash_background.6ec79e98.jpg";